import stylesheet from './SidebarFilter.scss?inline';

import CustomComponent from '../../base/customComponent/CustomComponent';
import {AbstractConstructor, withLayer} from '../../base/layer/withLayer';
import '../../parts/icon/icon';
import '../../parts/button/button';

class NXTSidebarFilter extends withLayer(CustomComponent as AbstractConstructor<CustomComponent>) {
    private rootElement: HTMLElement;

    constructor() {
        super();
        this.customStyle = stylesheet;
    }

    get labelClose(): string {
        return this.getAttribute('label-close') ?? 'Close filters';
    }

    render() {
        this.rootElement = document.createElement('div');
        this.rootElement.classList.add('sidebar-filter');
        this.rootElement.innerHTML = `
            <button class="trigger" type="button" aria-expanded="false">
                <span><slot name="label-trigger">Filter</slot></span>
                <nxt-icon icon="filter-list"></nxt-icon>
            </button>
            <div class="overlay">
                <div class="backdrop"></div>
                <div class="panel" role="dialog" aria-modal="true">
                    <div class="panel-header">
                        <div class="count"><slot name="count"></slot></div>
                        <button class="clear-inline" type="button"><slot name="label-clear-all">Clear all</slot> <nxt-icon icon="refresh"></nxt-icon></button>
                        <button class="close" type="button" aria-label="${this.labelClose}"><nxt-icon icon="close"></nxt-icon></button>
                    </div>
                    <div class="groups"><slot></slot></div>
                    <div class="panel-footer">
                        <nxt-button class="clear-footer" type="secondary" icon-left="refresh" block size="xl"><slot name="label-clear">Clear</slot></nxt-button>
                        <nxt-button class="see-results" type="primary" icon-right="arrow-forward" block size="xl"><slot name="label-see-results">See results</slot></nxt-button>
                    </div>
                </div>
            </div>
        `;

        this.rootElement.querySelector('.trigger').addEventListener('click', () => this.setOpen(true));
        this.rootElement.querySelector('.close').addEventListener('click', () => this.setOpen(false));
        this.rootElement.querySelector('.see-results').addEventListener('click', () => this.setOpen(false));
        this.rootElement.querySelector('.backdrop').addEventListener('click', () => this.setOpen(false));
        this.rootElement.querySelectorAll('.clear-inline, .clear-footer').forEach((btn) =>
            btn.addEventListener('click', () => {
                this.dispatchEvent(new Event('clear-filters', {bubbles: true, composed: true}));
            }),
        );

        return this.rootElement;
    }

    private setOpen(open: boolean) {
        this.rootElement.classList.toggle('open', open);
        this.rootElement.querySelector('.trigger').setAttribute('aria-expanded', String(open));
        // Lock page scroll while the bottom-sheet is open so only the panel scrolls.
        document.body.style.overflow = open ? 'hidden' : '';
    }

    disconnectedCallback() {
        document.body.style.overflow = '';
    }
}

customElements.define('nxt-sidebar-filter', NXTSidebarFilter);
